import React, { useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, AllCommunityModule, ModuleRegistry, themeBalham } from 'ag-grid-community';
import { TListePrix } from '../../../utils/types/tables/TListePrix';

ModuleRegistry.registerModules([AllCommunityModule]);

interface TListePrixGridProps {
    listePrix: TListePrix[];
    isLoading?: boolean;
}

const TListePrixGrid: React.FC<TListePrixGridProps> = ({ listePrix, isLoading }) => {
    const gridRef = useRef<AgGridReact>(null);

    useEffect(() => {
        if (!gridRef.current?.api) return;
        if (isLoading) {
            gridRef.current.api.showLoadingOverlay();
        } else if (!listePrix.length) {
            gridRef.current.api.showNoRowsOverlay();
        } else {
            gridRef.current.api.hideOverlay();
        }
    }, [isLoading, listePrix]);

    const columnDefs: ColDef<TListePrix>[] = [
        {
            field: 'nom',
            headerName: 'Nom',
            sortable: true,
            filter: true,
            flex: 3,
        },
        {
            field: 'isActive',
            headerName: 'Actif',
            sortable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <div style={{ textAlign: 'center' }}>
                    <input type="checkbox" checked={params.value ?? false} readOnly />
                </div>
            ),
            cellStyle: { textAlign: 'center' },
            flex: 0.5,
        },
    ];

    const myTheme = themeBalham.withParams({ columnBorder: { style: 'dashed', width: '1px' } });

    const handleGridReady = (params: any) => {
        params.api.autoSizeAllColumns();
        if (isLoading) {
            params.api.showLoadingOverlay();
        }
    };

    return (
        <div style={{ height: '100vh', width: '100%' }}>
            <AgGridReact
                ref={gridRef}
                theme={myTheme}
                getRowId={(params) => params.data.id?.toString() ?? ''}
                rowData={isLoading ? [] : listePrix}
                columnDefs={columnDefs}
                pagination
                domLayout="normal"
                defaultColDef={{ resizable: true, editable: false, minWidth: 100 }}
                onGridReady={handleGridReady}
                enableCellTextSelection
                ensureDomOrder
                animateRows
                loadingOverlayComponent={() => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div
                            style={{
                                width: 20,
                                height: 20,
                                border: '3px solid #ccc',
                                borderTop: '3px solid #2196f3',
                                borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite',
                            }}
                        />
                        <span>Chargement...</span>
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                    </div>
                )}
                overlayNoRowsTemplate="<span style='padding: 10px;'>Aucune donnée ...</span>"
            />
        </div>
    );
};

export default TListePrixGrid;
